module.exports = __webpack_public_path__ + "66d975394ce702acd126092521bb882b.pdf";